import { useEffect, useState } from 'react'

import SearchIcon from '../../../../../assets/search.svg'
import { parseDate } from '../../../../utils/date'


const SearchBar = ({ conversations, setFilteredConversations }) => {
  const [searchValue, setSearchValue] = useState('')

  const handleSearch = (event) => {
    const value = event.target.value
    setSearchValue(value)
    const filteredConversations = conversations.filter((conversation) => (
      conversation.name.toLowerCase().includes(value.toLowerCase()) ||
      parseDate(conversation.lastInteraction).includes(value.toLowerCase())
    ))
    setFilteredConversations(filteredConversations)
  }

  useEffect(() => {
    setSearchValue('')
    setFilteredConversations(conversations)
  }, [conversations, setFilteredConversations])

  return (
    <div className="flex w-full items-center rounded-2xl border border-primary/10 bg-white px-3 py-2 shadow-[0_10px_24px_rgba(15,23,42,0.05)] sm:w-[320px]">
      <input
        value={searchValue}
        onChange={handleSearch}
        className="w-full min-w-0 border-none bg-transparent text-sm text-text placeholder:text-muted focus:outline-none focus:ring-0 sm:text-base"
        placeholder="Buscar chat"
      />
      <img src={SearchIcon} className="ml-2 h-4 w-4 shrink-0 opacity-70" />
    </div>
  )
}

export default SearchBar
